import { motion } from "framer-motion";
import { BrandLogo } from "@/components/BrandLogo";

export const BrandedLoader = ({ label }) => {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4, ease: "easeInOut" }}
      className="absolute inset-0 z-30 flex flex-col items-center justify-center bg-[#050505] overflow-hidden"
      data-testid="branded-loader"
    >
      {/* Skeleton webpage behind the brand */}
      <div className="absolute inset-0 opacity-[0.5] p-6 md:p-10">
        <div className="mx-auto max-w-3xl w-full space-y-6">
          <div className="flex items-center justify-between">
            <div className="shimmer h-6 w-32 rounded-md" />
            <div className="flex gap-3">
              <div className="shimmer h-6 w-16 rounded-md" />
              <div className="shimmer h-6 w-16 rounded-md" />
              <div className="shimmer h-6 w-20 rounded-full" />
            </div>
          </div>
          <div className="shimmer h-56 w-full rounded-2xl" />
          <div className="grid grid-cols-3 gap-4">
            <div className="shimmer h-28 rounded-xl" />
            <div className="shimmer h-28 rounded-xl" />
            <div className="shimmer h-28 rounded-xl" />
          </div>
          <div className="space-y-3">
            <div className="shimmer h-4 w-3/4 rounded" />
            <div className="shimmer h-4 w-2/3 rounded" />
            <div className="shimmer h-4 w-1/2 rounded" />
          </div>
        </div>
      </div>

      {/* Brand focus */}
      <div className="relative z-10 flex flex-col items-center gap-6 px-6 text-center">
        <div className="relative flex items-center justify-center">
          <span className="absolute h-16 w-16 rounded-full border border-white/10" />
          <motion.span
            className="absolute h-16 w-16 rounded-full border-2 border-transparent border-t-white/80"
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
          />
          <div className="h-16 w-16 rounded-full bg-white/5 backdrop-blur-sm flex items-center justify-center">
            <span className="h-3 w-3 rounded-sm bg-white" />
          </div>
        </div>
        <BrandLogo />
        <div className="flex flex-col items-center gap-1">
          <p className="text-sm text-white/70 font-medium" data-testid="loader-label">
            {label || "Preparing preview"}
          </p>
          <div className="mt-1 h-1 w-40 overflow-hidden rounded-full bg-white/10">
            <motion.div
              className="h-full w-1/3 rounded-full bg-white/80"
              animate={{ x: ["-120%", "360%"] }}
              transition={{ repeat: Infinity, duration: 1.3, ease: "easeInOut" }}
            />
          </div>
        </div>
      </div>
    </motion.div>
  );
};
